import React, { useState } from "react";
import { usePlacesWidget } from "react-google-autocomplete";

export default function SearchForm({
  sectionData,
  categories,
  currentCategory,
  onCurrentCategory,
  onSearch,
  maps,
}) {
  const countryCode = sectionData?.restrict_by_store_country
    ? sectionData?.shop?.countryCode
    : sectionData?.restrict_to_country_codes || null;
  const unit = isMetric() ? "km" : "mi";
  const miToKmConstant = 1.609344;
  const defaultRadius = 10;
  const radiusOptions = [2, 5, 10, 15, 20, 30, 50, 75, 100].map((n) => {
    return { value: n, label: `${n}${unit}` };
  });

  function isMetric() {
    return sectionData?.shop?.unitSystem === "metric";
  }

  // Return here because usePlacesWidget needs global google maps object
  if (!maps) return null;

  const { ref } = usePlacesWidget({
    options: {
      types: ["street_number", "route", "postal_code", "locality"],
      ...(!!countryCode && {
        componentRestrictions: {
          country: countryCode,
        },
      }),
    },
    onPlaceSelected: (place) => {
      setLatLngInput(place.geometry?.location);
    },
  });

  const [radiusInput, setRadiusInput] = useState(defaultRadius);
  const [latLngInput, setLatLngInput] = useState(null);
  const [inputError, setInputError] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();

    const inputValue = ref.current.value;
    if (!inputValue) {
      setInputError(true);
      return;
    }

    let latLng = latLngInput;

    if (!latLng) {
      const geocoder = new maps.Geocoder();
      let results, status;

      try {
        await geocoder.geocode(
          {
            address: inputValue,
            region: countryCode,
          },
          (r, s) => {
            results = r;
            status = s;
          }
        );
      } catch (error) {
        console.error(error.message);
      }

      if (status == maps.GeocoderStatus.OK) {
        latLng = results[0]?.geometry.location;
        setLatLngInput(latLng);
      } else if (status == maps.GeocoderStatus.ZERO_RESULTS) {
        setInputError(true);
        return;
      }
    }

    // Km to meters
    let radius = parseFloat(radiusInput) * 1000;
    if (!isMetric()) {
      // Meters to miles
      radius *= miToKmConstant;
    }

    onSearch(latLng, radius);
  }

  return (
    <form onSubmit={onSubmit} className="location-form">
      {!!categories.length && (
        <div className="location-form__categories">
          {categories.map((category) => (
            <button
              key={category}
              type="button"
              className={"location-form__category".concat(
                currentCategory == category ? " active" : ""
              )}
              onClick={() => onCurrentCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      )}

      <div className="location-form__fields">
        <div className="location-form__radius select">
          <select
            className="field__input"
            onChange={(e) => setRadiusInput(e.target.value)}
            defaultValue={defaultRadius}
          >
            {radiusOptions.map((option) => {
              return (
                <option key={option} value={option.value}>
                  {option.label}
                </option>
              );
            })}
            ;
          </select>
          {sectionData?.dropdownArrowSVG && (
            <span
              dangerouslySetInnerHTML={{
                __html: sectionData.dropdownArrowSVG,
              }}
            ></span>
          )}
        </div>

        <div className="location-form__address-wrapper">
          <div className="location-form__address field">
            <input
              ref={ref}
              onInput={() => {
                setInputError(false);
                setLatLngInput(null);
              }}
              type={"text"}
              className={`field__input ${
                inputError ? "field__input--error" : ""
              }`.trim()}
              placeholder="Enter your city, suburb or posctode"
            />
          </div>
          <div className="location-form__submit-wrapper">
            <button className="button button--primary">
              Search
              {sectionData?.searchSVG && (
                <span
                  dangerouslySetInnerHTML={{ __html: sectionData.searchSVG }}
                ></span>
              )}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
